import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { CONSULT_PATIENT } from './consult-patient.constants';
import { ConsultPatientService } from './consult-patient.service';

@Component({
  selector: 'ms-consult-patient',
  templateUrl: './consult-patient.component.html',
})
export class ConsultPatientComponent
  extends BaseComponent
  implements AfterViewInit
{
  override readonly screen = CONSULT_PATIENT;
  @ViewChild('saveButtons', { static: true }) private saveButtons?: ElementRef;
  @Input() patient: CommonPatientViewModel = {};
  @Input() edit = false;
  @Input() sticky = false;
  @Output() stickyChange = new EventEmitter<boolean>();
  @Output() saveConsult = new EventEmitter<{
    draft: boolean;
    isReport?: boolean;
  }>();
  @Input() saving = false;
  historyPdf?: SafeResourceUrl;
  showHistoryPdf = false;
  private buttonsOffset = 0;

  constructor(
    protected route: ActivatedRoute,
    override service: ConsultPatientService
  ) {
    super();
  }

  override onInit = () => {
    this.subscriptions.push(
      this.service.readHistoryPdfStore().subscribe(this.onHistoryGenerated)
    );
  };

  ngAfterViewInit(): void {
    this.buttonsOffset = this.saveButtons!.nativeElement.offsetTop;
  }

  @HostListener('window:scroll')
  onWindowScroll = () => {
    if (window.pageYOffset > this.buttonsOffset) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }
  };

  openPatientDialog = () =>
    this.service.openPatientDialog().onClose.subscribe((modalResult) => {
      if (modalResult) {
        this.patient = modalResult;
        this.subscriptions.push(
          this.service.getPatientById(this.patient.id!).subscribe(),
          this.service.getPersonById(this.patient.person!).subscribe()
        );
      }
    });

  save = (isReport: boolean = false) =>
    this.saveConsult.emit({ draft: true, isReport });

  onHistoryGenerated = (file?: SafeResourceUrl) => {
    this.historyPdf = file;
    this.showHistoryPdf = file != null;
  };
}
